//import { reviewAccomodationStars } from '../helpers.js';

var reviewAccomodationStars = {
  options: {
  },

  selectors: {
    "stars": ".js-review-accomodation-stars",
  },

  init: function () {
    const self = this;

    self.setValidity();
    self.bindEvents();
  },

  setValidity: function () {
    const self = this;

    jQuery(self.selectors.stars).children("input[type='text']").each(function (index) {
      jQuery(this)[0].setCustomValidity(jQuery(this).data("empty-message"));
    });
  },

  bindEvents: function () {
    const self = this;

    jQuery(self.selectors.stars).children("span").on("mouseover", function (event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        self.changeStars(jQuery(this).closest(self.selectors.stars), parseInt(jQuery(this).data("star-index")));
      }
    });

    jQuery(self.selectors.stars).on("mouseout", function (event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        self.changeStars(this, parseInt(jQuery(this).children("input[type='hidden']").val()));
      }
    });

    jQuery(self.selectors.stars).children("span").on("click", function () {
      self.changeStars(jQuery(this).closest(self.selectors.stars), parseInt(jQuery(this).data("star-index")), true);
    });
  },

  changeStars: function (stars_el, stars_count, save = false) {
    const self = this;

    if (save) {
      jQuery(stars_el).children("input[type='hidden']").val(stars_count);
      jQuery(stars_el).children("input[type='text']")[0].setCustomValidity("");
    }

    //fill stars
    for (let i = 0; i <= stars_count; i++) {
      jQuery(stars_el).children("span[data-star-index='" + i + "']").addClass("filled");
    }

    //empty stars
    for (let i = (stars_count + 1); i <= 5; i++) {
      jQuery(stars_el).children("span[data-star-index='" + i + "']").removeClass("filled");
    }
  },
}

// Export
export { reviewAccomodationStars };